// Build-time environment, read once.
//
// `const WORKER_URL = import.meta.env.VITE_WORKER_URL || ''` was written out
// independently in 21 files. Vite inlines the value at build time either way,
// so this is about there being one name for it rather than about cost.

/** Base URL of the Cloudflare Worker API. Empty string in dev, where Vite
 *  proxies /api to the staging worker (see vite.config.ts). */
export const WORKER_URL: string = (import.meta.env.VITE_WORKER_URL as string | undefined) || ''
